import { useEffect, useState } from 'react'
import { api, type BetLimit } from '@/lib/api'

/**
 * "CHOOSE YOUR BET LIMIT" — the reference entry screen before the board.
 *
 * The rows are the ones this member's agent offers (the house's active limits, narrowed by
 * its master and agent), so two members can see different lists. A bet names the row by id.
 */
export function BetLimitPage({ onChoose }: { onChoose: (limit: BetLimit) => void }) {
  const [limits, setLimits] = useState<BetLimit[] | null>(null)
  const [failed, setFailed] = useState(false)
  const [attempt, setAttempt] = useState(0)

  useEffect(() => {
    let live = true
    setFailed(false)
    api.betLimits()
      .then((r) => { if (live) setLimits(r.limits) })
      .catch(() => { if (live) setFailed(true) })
    return () => { live = false }
  }, [attempt])

  return (
    <>
      <div className="betlimitpop">
        <h2>CHOOSE YOUR BET LIMIT</h2>
        {failed && (
          <a href="/" onClick={(e) => { e.preventDefault(); setAttempt((n) => n + 1) }}>
            <div>Unable to load bet limits. Tap to retry.</div>
          </a>
        )}
        {!failed && limits !== null && limits.length === 0 && (
          <div style={{ padding: '12px 16px', textAlign: 'center', color: '#cfd8ff' }}>
            No bet limit is available for your account. Please contact your agent.
          </div>
        )}
        {(limits ?? []).map((l) => (
          <a key={l.id} href="/" onClick={(e) => { e.preventDefault(); onChoose(l) }}>
            <div>
              {'\n        Min '}<span>{l.min}</span>{' \n        Max '}<span>{l.max}</span>
            </div>
          </a>
        ))}
      </div>
      <div style={{ textAlign: 'right' }}>Version 2025.10.288.1</div>
    </>
  )
}
